import { Platform } from "react-native";

export const isWeb = Platform.OS === "web";

export function openLink(url: string): void {
  if (isWeb) {
    window.open(url, "_blank");
  }
}
